let handleAgentListResponse: (names: string[], statuses: string[]) => void;

export const setHandleAgentListResponse = (
  handler: (names: string[], statuses: string[]) => void
) => {
  handleAgentListResponse = handler;
};

export const triggerHandleAgentListResponse = (names: string[], statuses: string[]) => {
  if (handleAgentListResponse) {
    handleAgentListResponse(names, statuses);
  } else {
    console.warn("Agent list handler is not set");
  }
};
